// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"937":"2b2fa6d7","948":"e9bd8c89"}[chunkId] + ".chunk.css";
};